import { Pipe, PipeTransform } from '@angular/core';
import { ChatParticipant } from 'src/app/services/http-services/chat/chat-http-interfaces';
import {UserRoles} from '../../enums/general-enums';
import {AuthenticationHelperService} from '../../services/helpers/authentication-helper.service';

@Pipe({
  name: 'getUserData',
  standalone: true
})
export class GetUserDataPipe implements PipeTransform {

  constructor(public authenticationHelperService: AuthenticationHelperService) {
  }

  transform(userId: number, participants: ChatParticipant[] | undefined, dataType: 'username' | 'image'): string {
    const participant = participants?.find(p => p.id === userId);

    if (participant) {
      if (dataType === 'username') {
        return participant.username;
      } else if (dataType === 'image') {
        return participant.profile_photo_url ? participant.profile_photo_url : (this.authenticationHelperService.checkActiveSubscription(participant.subscriptions) === UserRoles.expert || this.authenticationHelperService.checkActiveSubscription(participant.subscriptions) === UserRoles.company ? '../../../../assets/images/avatar-user-expert.png' : '../../../../assets/images/avatar-user.png');
      }
    }

    return dataType === 'username' ? 'Unknown User' : '../../../../assets/images/avatar-user.png';
  }

}
